
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import ModelDrawer from "@/views/ai-builder-v3/components/drawer/index.vue";
import {
  BasicQuality,
  ProcessInformation
} from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
import { ExamV3Tem } from "@/lib/model/exambuilder/exam-v3/exam-v3";

import {
  jobMatchingEnum,
  physicalInstrumentEnum,
  knowledgeAndSkillsEnum,
  psychologicalMotivationEnum
} from "@/lib/enum/tool";

import { Mind, PsycGaugeConfig } from "@/lib/model/exambuilder/exam-v2";

@Component({
  components: { ModelDrawer }
})
export default class ModelCard extends Vue {
  // 选中项
  @Prop({ type: Number, default: 0 })
  select!: number;
  @Prop({ default: () => [] as ExamV3Tem[] })
  templateList!: ExamV3Tem[];
  @Prop({ default: () => [new PsycGaugeConfig()] })
  mindList!: PsycGaugeConfig[]; // 心理测评list
  @Prop({ default: false }) isTemplateNextAfter!: boolean; // 是否进入过下一步

  bg = require("@/assets/20240227-105838.jpeg");
  detailText = "查看详情";
  detailIndex = 0;
  visible = false;
  isResumeExam = false; //是否继续创建面试

  // 时间
  getQuestionTime(second: number) {
    const m = Math.floor(second / 60);
    const s = second % 60;
    return `${m + Number(Boolean(s))}min`;
  }
  // 重点考查
  emphasisInspection(basicQualityList: BasicQuality[]) {
    const str = basicQualityList.reduce((pre: string, item: BasicQuality) => {
      pre += item.dimensionName + "、";
      return pre;
    }, "");
    return str.slice(0, str.length - 1);
  }
  // 其他考查
  otherInspection(processInformation: ProcessInformation) {
    let str = "";
    const {
      knowledgeAndSkills,
      physicalInstrument,
      jobMatching,
      psychologicalMotivation
    } = processInformation;
    // 体质仪表
    if (physicalInstrument.colorTest && physicalInstrument.colorTest.use === 1)
      str += physicalInstrument.colorTest.name + "、";
    if (physicalInstrument.fingerTest.use === 1)
      str += physicalInstrument.fingerTest.name + "、";
    // 工作匹配
    if (jobMatching.identityInfo === 1)
      str += jobMatchingEnum.identityInfo + "、";
    if (jobMatching.socialInfo === 1) str += jobMatchingEnum.socialInfo + "、";
    if (jobMatching.financialRisk === 1)
      str += jobMatchingEnum.financialRisk + "、";

    // 知识技能
    if (
      knowledgeAndSkills.gameTestList[0] &&
      knowledgeAndSkills.gameTestList[0].gameTestType === 1
    ) {
      str += "风险偏好小游戏、";
    }
    if (
      knowledgeAndSkills.iseChinese &&
      knowledgeAndSkills.iseChinese.use === 1
    ) {
      str += knowledgeAndSkills.iseChinese.name + "、";
    }
    if (
      knowledgeAndSkills.iseEnglish &&
      knowledgeAndSkills.iseEnglish.use === 1
    ) {
      str += knowledgeAndSkills.iseEnglish.name + "、";
    }

    // 心理动机
    this.mindList.forEach(psycConfig => {
      const psyUse = psychologicalMotivation["psyc" + psycConfig.psycGaugeId];
      if (psyUse.use === 1) {
        psyUse.name = psycConfig.psycGaugeName;
        str += psycConfig.psycGaugeName + "、";
      }
    });
    return str.slice(0, str.length - 1);
  }

  selectTarget(e: Event, templateId: number) {
    if (e.target && (e.target as HTMLElement).innerText === this.detailText) {
      this.detailIndex = templateId;
      this.visible = true;
    } else {
      const flag = this.isTemplateNextAfter || this.isResumeExam;
      if (flag) {
        const examV3Tem = this.templateList.find(
          item => item.templateId === templateId
        );
        this.$emit("nextAfter", {
          nextAfter: flag,
          examV3Tem: examV3Tem
        });
        return;
      } else {
        this["update:select"](templateId);
        this.template(templateId);
      }
    }
  }
  // 回传模版信息
  template(templateId: number) {
    const examV3Tem = this.templateList.find(
      item => item.templateId === templateId
    );
    this.$emit("targetTemplate", examV3Tem);
  }
  // 详情
  get targetDetail() {
    const target = this.templateList.find(
      item => item.templateId === this.detailIndex
    );
    return target;
  }
  @Emit()
  "update:select"(templateId: number) {
    return templateId;
  }
  // 	取消
  handleClose(select: boolean) {
    if (select) {
      if (this.isTemplateNextAfter) {
        const examV3Tem = this.templateList.find(
          item => item.templateId === this.detailIndex
        );
        this.$emit("nextAfter", {
          nextAfter: this.isTemplateNextAfter,
          examV3Tem: examV3Tem
        });
        return;
      } else {
        this["update:select"](this.detailIndex);
        this.template(this.detailIndex);
      }
    }
    this.visible = false;
  }
}
